import { Loader, Tooltip, icons } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React from 'react'

import { Result } from 'services/results/types'

import { StateText, StateWrapper, StatusIconWrapper } from './ResultState.styles'

type Props = {
  state: Result
}

export const PREPARING_STATUS_TOOLTIP =
  'The participant file is being generated. This request can be reviewed once the file is ready.'

const ResultState = ({ state }: Props) => {
  switch (state.status) {
    case ResultsState.Complete:
      return (
        <StateWrapper>
          <StatusIconWrapper status={state.status}>
            <icons.CheckInCircleSmall data-testid="approved-icon" />
          </StatusIconWrapper>
          <StateText>Approved</StateText>
        </StateWrapper>
      )
    case ResultsState.PendingVerification:
      return (
        <StateWrapper>
          <StatusIconWrapper status={state.status}>
            <icons.ClockSmall data-testid="pending-icon" />
          </StatusIconWrapper>
          <StateText>Pending</StateText>
        </StateWrapper>
      )
    case ResultsState.Rejected:
      return (
        <StateWrapper>
          <StatusIconWrapper status={state.status}>
            <icons.CloseInCircleSmall data-testid="rejected-icon" />
          </StatusIconWrapper>
          <StateText>Rejected</StateText>
        </StateWrapper>
      )
    case ResultsState.Failed:
      return (
        <Tooltip title={state.failureReason}>
          <StateWrapper>
            <StatusIconWrapper status={state.status}>
              <icons.ErrorSmall data-testid="failed-icon" />
            </StatusIconWrapper>
            <StateText>Failed</StateText>
          </StateWrapper>
        </Tooltip>
      )
    case ResultsState.Preparing:
      return (
        <Tooltip title={PREPARING_STATUS_TOOLTIP}>
          <StateWrapper>
            <StatusIconWrapper status={state.status} data-testid="preparing-icon">
              <Loader text={false} />
            </StatusIconWrapper>
            <StateText>Preparing...</StateText>
          </StateWrapper>
        </Tooltip>
      )
    case ResultsState.Processing:
      return (
        <StateWrapper>
          <StatusIconWrapper status={state.status}>
            <Loader text={false} />
          </StatusIconWrapper>
          <StateText>Processing...</StateText>
        </StateWrapper>
      )
    default:
      return null
  }
}

export default ResultState
